export const isValidHttpUrl = (url: string | null) => {
  try {
    if (url) {
      const urlPattern = new RegExp('^(https?:\\/\\/)');
      const isValid = urlPattern.test(url);
      if (!isValid) {
        return `https://${url}`;
      }
      return url;
    }
    return '';
  } catch (err) {
    return '';
  }
};
